// extracted by mini-css-extract-plugin
export var copyableField = "_rq-4";
export var customerBadge = "_rq-0";
export var customerInfoTitle = "_rq-2";
export var details = "_rq-1";
export var dropdownContainer = "_rq-5";
export var dropdownImage = "_rq-6";
export var editAssigneeForm = "_rq-a";
export var editButton = "_rq-3";
export var email = "_rq-7";
export var hidden = "_rq-d";
export var input = "_rq-8";
export var saveButton = "_rq-b";
export var shopifyIcon = "_rq-c";
export var suggestionBadge = "_rq-e";
export var suggestionText = "_rq-f";
export var username = "_rq-9";